module.exports = __webpack_public_path__ + "static/img/section_06_bg.4af2235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010110/section_06_bg.png
// module id = AaLC
// module chunks = 10